import * as React from 'react';
import { StudentData, StudentCredentials } from '../../models/Student';
import { RouteComponentProps } from 'react-router';
import * as Modal from 'react-modal';
import { Popup } from '../Common/popup';
import { genPassword } from './../../utils/tools';

export namespace StudentInfo {
	export interface Props extends RouteComponentProps<void> {
		student: StudentData;
		newStudent: boolean;
		actions: Actions;
	}

	export interface State {
		modalOpen: boolean;
		firstname: string;
		lastname: string;
		changingPass: boolean;
	}

	export interface Actions {
		updateStudentNames: (e: any) => void;
		updateStudentCredentials: (studentCreds: StudentCredentials) => void;
		deleteStudent: (e: any) => void;
		sendEmail: (e: any) => void;
		createUsernames: (e: any) => void;
		sendEmails: (e: any) => void;
	}
}

export class StudentInfo extends React.Component<StudentInfo.Props, StudentInfo.State> {

	private username: HTMLInputElement;
	private email: HTMLInputElement;
	private student: StudentData;
	private password: HTMLInputElement;

	constructor(props: StudentInfo.Props) {
		super(props);
		this.updateStudent = this.updateStudent.bind(this);
		this.deleteStudent = this.deleteStudent.bind(this);
		this.changeName = this.changeName.bind(this);
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);

		this.state = {
			modalOpen: false,
			lastname: this.props.student.lastname,
			firstname: this.props.student.firstname,
			changingPass: false
		}
	}

	componentDidMount() {
		if (this.props.newStudent) {
			this.setState({ changingPass: true }, () => {
				this.devNewPassword();
			});
		}
	}

	componentWillReceiveProps(nextProps: StudentInfo.Props) {
		this.setState({
			firstname: nextProps.student.firstname,
			lastname: nextProps.student.lastname,
			changingPass: nextProps.newStudent
		}, () => {
			if (nextProps.newStudent) {
				this.devNewPassword();
			}
		});
	}

	changeName(values: any) {
		this.setState({
			modalOpen: false
		});
		this.updateStudent(null, values.firstname, values.lastname);
	}

	updateStudent(e?: any, firstname?: string, lastname?: string) {
		if (e)
			e.preventDefault();

		const studentData: StudentData = {
			group: this.props.student.group,
			_id: this.props.student._id,
			firstname: this.props.student.firstname,
			lastname: this.props.student.lastname,
			username: this.username.value,
			email: ''// this.email.value 
		};

		if (firstname)
			studentData.firstname = firstname;
		if (lastname)
			studentData.lastname = lastname;

		this.props.actions.updateStudentNames(studentData);
	}

	deleteStudent(e: any) {
		e.preventDefault();
		this.props.actions.deleteStudent(this.props.student);
	}

	openModal(e: any) {
		e.preventDefault();
		this.setState({ modalOpen: true });
	}

	closeModal(e?: any) {
		if (e)
			e.preventDefault();
		this.setState({ modalOpen: false });
	}

	enablePassChange = () => {
		this.password.value = this.state.changingPass ? "qwerty" : "";
		this.setState((prevState) => {
			return {
				changingPass: !!!prevState.changingPass
			}
		});
	}

	devNewPassword = () => {
		this.password.value = genPassword();

	}

	updatePassword = () => {
		this.props.actions.updateStudentCredentials({
			group_id: this.props.student.group,
			student_id: this.props.student._id,
			username: null,
			password: this.password.value
		});

		this.enablePassChange();
	}

	updateUsername = () => {
		this.props.actions.updateStudentCredentials({
			group_id: this.props.student.group,
			student_id: this.props.student._id,
			username: this.username.value,
			password: null
		});
	}

	render() {
		let student = this.props.student;

		let popupelement = (
			<div>
				<h4>Anna oppilaan nimi</h4>
				<Popup.Form
					inputs={[{ name: 'firstname', type: 'text', placeholder: 'etunimi', value: this.state.firstname }, { name: 'lastname', type: 'text', placeholder: 'sukunimi', value: this.state.lastname }]}
					buttons={[{ text: 'TALLENNA OPPILAS', image: '/images/GreenPlusButton.png' }]}
					accept={this.changeName}
				/>
			</div>
		);

		return (
			<div>
				<p><b>Oppilaan tiedot</b></p>
				<div className="am_fitContent am_innercontainer" key={student._id}> {/*key updates default values*/}
					<div className="margin10">
						<img src="/images/OnePerson.png" className="am_smallicon"></img>
						<h5 className="am_inline">{this.state.firstname} {this.state.lastname} </h5>
						<button onClick={this.openModal} className="btn am_darkblue-button am_smallbutton am_shadow">MUUTA NIMEÄ</button>
					</div>
					<div>
						<div className="col-12">
							<label className="col-3"><b>Tunnus: </b></label><input ref={(username) => { this.username = username }} defaultValue={student.username} className="col-9"></input>
						</div>
						<div className="col-12 stu_inter_pass_wrapper">
							<label className="col-3">
								<b>Salasana: </b>
							</label>
							{(this.state.changingPass)
								? (
									<>
										<input
											ref={(password) => { this.password = password }}
											type="text" className="col-9 stu_inter_pass"
										/>
										<button
											onClick={this.devNewPassword}
											className="btn am_darkblue-button am_shadow stu_pass_interact_change"
										>Kehitä uusi salasana</button>
									</>
								)
								: (
									<>
										<input
											ref={(password) => { this.password = password }}
											type="password" defaultValue="qwerty"
											className="col-9 stu_inter_pass_disabled"
											disabled
										/>
										<button
											onClick={this.enablePassChange}
											className="btn am_darkblue-button am_shadow stu_pass_interact_dev"
										>Vaihda salasana</button>
									</>
								)
							}
						</div>
						<div className="col-12">
							{/*<label className="col-3"><b>S-posti: </b></label><input ref={(email)=>{this.email=email}} defaultValue={student.email} className="col-9"></input>*/}
						</div>
						<div className="row mt-2">
							{/*<button className="btn am_blue-button am_smallbutton am_shadow mx-auto"><img src="/images/MailBlue.png" className="am_tinyicon"/>LÄHETÄ TUNNUS OPPILAAN SÄHKÖPOSTIIN</button>*/}
						</div>
						<div className={`teacherNotifierWrapper${(this.state.changingPass) ? "" : " am_hidden"}`}>
							<div className="am_innercontainer teacherNotifierContainer">
								<p>
									<b>Huomio!</b> Paina "Aktivoi tunnus"-painiketta vasta sen jälkeen kun olet kopioinut yllä näkyvän salasanan talteen. Aktivoinnin myötä et voi enää nähdä salasanaa, mutta voit kuitenkin vaihtaa sen uuteen.
							</p>
								<button onClick={(this.state.changingPass) ? this.updatePassword : this.enablePassChange} className="btn am_darkblue-button student_interact_button am_shadow">
									<img className="am_smallericon" src="/images/OnePerson.png" alt="not found"></img>
									Aktivoi tunnus
								</button>
							</div>
						</div>
						<div className="row mt-3 p-3">
							<div className="col-12 mb-2">
								<button onClick={this.updateUsername} className="btn am_green-button am_shadow col-12"><img src="/images/GreenConfirmButton.png" className="am_smallicon" />TALLENNA MUUTOKSET</button>
							</div>

							<div className="col-12">
								<button onClick={this.deleteStudent} className="btn am_darkblue-button am_shadow col-12"><img src="/images/CrossButton.png" className="am_smallicon" />POISTA OPPILAS</button>
							</div>
						</div>
					</div>
				</div>
				{/*<button className="btn am_orange-button am_shadow col-12 m-1 am_smalltext"><img src="/images/GreenConfirmButton.png" className="am_smallicon"/>LUO RYHMÄN KAIKILLE OPPILAILLE KERRALLA UUDET TUNNUKSET</button>
				<button className="btn am_blue-button am_shadow col-12 m-1 am_smalltext"><img src="/images/MailBlue.png" className="am_smallicon"/>LÄHETÄ KAIKILLE RYHMÄN OPPILAILLE TUNNUKSET SÄHKÖPOSTIIN</button>*/}
				<Modal isOpen={this.state.modalOpen} contentLabel="Minimal Modal Example" style={Popup.modalStyle}>
					<Popup.Element element={popupelement} closeModal={this.closeModal} />
				</Modal>
			</div >
		);
	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/GroupSettings/studentinfo.tsx